<div class="modelContainer">
  <div class="">
    <button (click)="onCancelClick(false)" type="button" class="close cancelBtn" aria-label="Close" mat-dialog-close>
      Close
    </button>
  </div>
  <div class="modelTitle heading2 alignCenter">
    <span *ngIf="data.displayType=='add'">Create Tenant</span>
    <span *ngIf="data.displayType=='view'">View Tenant</span>
    <span *ngIf="data.displayType=='edit'">Edit Tenant</span>
  </div>
  <div class="modelBody regularText">
    <form [formGroup]="tenantDetailForm">
      <div *ngIf="isLoading" class="svg-loader"></div>
      <div class="form-group row">
        <div class="col-1"></div>
        <label for="tenantName" class="col-4 mandatory-field no-padding"><strong>Tenant Name</strong></label>
        <div class="col-6 zero-padding">
          <input type="text" maxlength="15" formControlName="tenantName" class="form-control" id="tenantName" required />
        </div>
        <div class="col-1"></div>
      </div>
      <div class="form-group row mt-3">
        <div class="col-1"></div>
        <label for="tenantSecurityGrp" class="col-4 mandatory-field no-padding"><strong>Security Group</strong></label>
        <div class="col-6 zero-padding">
          <input type="text" formControlName="tenantSecurityGrp" class="form-control" id="tenantSecurityGrp" required />
        </div>
        <div class="col-1"></div>
      </div>
      <div class="form-group row mt-3">
        <div class="col-1"></div>
        <label for="tenantEmailId" class="col-4 mandatory-field no-padding"><strong>Email id</strong></label>
        <div class="col-6 zero-padding">
          <input type="text" formControlName="tenantEmailId" class="form-control" id="tenantEmailId" required />
        </div>
        <div class="col-1"></div>
      </div>
      <div class="form-group row mt-3">
        <div class="col-1"></div>
        <label for="refineryId" class="col-4 mandatory-field no-padding"><strong>Refinery</strong></label>
        <div class="col-6 zero-padding">
          <select id="refineryId" (change)="onRefineryChange()" class="form-control select-btn" required formControlName="refineryId">
            <option *ngFor="let element of refineryMap" [ngValue]="element.refineryId">{{element.refineryName}}</option>
          </select>
        </div>
        <div class="col-1"></div>
      </div>
      <div class="form-group row mt-3">
        <div class="col-1"></div>
        <label for="tenantKeyvaultUrl" class="col-4 mandatory-field no-padding"><strong>Key Vault</strong></label>
        <div class="col-6 zero-padding">
          <input type="text" formControlName="tenantKeyvaultUrl" class="form-control" id="tenantKeyvaultUrl" required />
        </div>
        <button *ngIf="data.displayType != 'view'" routerLinkActive="active" (click)="openKeyvaultPopup()" class="btn font-weight-bold addBtn" matTooltip="Create keyvault">+</button>
        <div class="col-1"></div>
      </div>
      <div class="d-flex alignCenter">
        <button id="createBtn" type="submit" *ngIf="data.displayType != 'view'" class="saveBtn2 mt-2" (click)="saveTenant()"
                [disabled]="disableSave()">
          Save
        </button>
      </div>
    </form>
  </div>
</div>
